import * as React from 'react'
import './TextWithTitle.scss'

export const TextWithTitle = ({text}: { text: string }) => {
    return <span className={'textOverflow'} title={text}>{text}</span>
}